/**
 * CATÁLOGO MESTRE CANÔNICO AUDITADO — SUPER LAZINHO AVENIDA 7
 * Saneamento Pós-Auditoria Axion (Missão 01.1 - 15/09/2026)
 * Fontes canônicas: Cardápio Super Lazin 01.pdf (Páginas 1 a 12)
 */

export const STORE_INFO = {
  name: "Super Lazinho Avenida 7",
  tagline: "Bar, Petiscaria e Pizzaria",
  address: "Av. Sete de Setembro, 1167 - Centro, Juiz de Fora - MG",
  // Número provisório para testes técnicos. NÃO HOMOLOGADO como canal oficial definitivo.
  whatsapp: "5532998486940",
  whatsappDisplay: "(32) 99848-6940 (Provisório / Em homologação)",
  whatsappStatus: "Canal provisório para teste técnico — pendente de homologação comercial com Lazinho",
  deliveryFee: null, // PENDENTE: A DEFINIR
  deliveryArea: "Pendente de confirmação comercial",
  businessHours: "Pendente de confirmação",
  deliveryTime: "Pendente de confirmação",
  minOrder: null, // Pendente de confirmação
  logo: "assets/logo-super-lazin-av7.png",
  diButecoBadge: "assets/selo-comida-di-buteco.jpg"
};

// Adicionais padrão de lanches homologados no cardápio (Página 8)
export const BURGER_ADDONS = [
  { id: "add-bife-hamb", name: "Bife de Hambúrguer", price: 5.00 },
  { id: "add-bife-art", name: "Bife Artesanal", price: 7.00 },
  { id: "add-catupiry-cheddar", name: "Catupiry ou Cheddar", price: 5.00 },
  { id: "add-ovo", name: "Ovo", price: 2.00 },
  { id: "add-mucarela", name: "Muçarela", price: 2.00 },
  { id: "add-maionese", name: "Maionese Caseira", price: 2.00 }
];

// Bordas recheadas de pizza homologadas no cardápio (Página 11)
export const PIZZA_EDGES = [
  {
    id: "edge-cheddar",
    name: "Borda de Cheddar",
    prices: { broto: 9.00, media: 12.00, familia: 16.00, mega: 18.00 }
  },
  {
    id: "edge-catupiry",
    name: "Borda de Catupiry",
    prices: { broto: 9.00, media: 12.00, familia: 16.00, mega: 18.00 }
  },
  {
    id: "edge-creamcheese",
    name: "Borda de Cream Cheese",
    prices: { broto: 11.00, media: 13.00, familia: 17.00, mega: 20.00 }
  }
];

export const CATEGORIES = [
  {
    id: "lanches",
    name: "Lanches",
    tagline: "Hambúrgueres tradicionais, picanha, artesanais e especiais",
    banner: "assets/abre-alas-lanches.png",
    hasAddons: true
  },
  {
    id: "jantinhas",
    name: "Jantinhas",
    tagline: "Prato completo com carnes selecionadas e acompanhamentos",
    banner: "assets/abre-alas-jantinha.png",
    isCustomFlow: true
  },
  {
    id: "pizzas",
    name: "Pizzas",
    tagline: "Clássicas, especiais, premium, doces, calzones e bordas recheadas",
    banner: "assets/abre-alas-pizzas.png",
    isPizza: true
  },
  {
    id: "di-buteco",
    name: "Di Buteco",
    tagline: "Pratos concorrentes oficiais do maior concurso de boteco do Brasil",
    banner: "assets/selo-comida-di-buteco.jpg",
    isDiButeco: true
  },
  {
    id: "porcoes",
    name: "Porções",
    tagline: "Iscas, filés, trios e petiscos tradicionais de boteco",
    banner: "assets/abre-alas-porcoes.png",
    supportsHalf: true // Meia porção a 60% do valor (Página 5)
  },
  {
    id: "para-compartilhar",
    name: "Para compartilhar",
    tagline: "Pastéis, bolinhos e petiscos para dividir",
    banner: "assets/abre-alas-para-compartilhar.png"
  },
  {
    id: "fritas",
    name: "Fritas",
    tagline: "Batatas fritas tradicionais e coberturas do cardápio",
    banner: "assets/abre-alas-fritas.png"
  },
  {
    id: "caldos",
    name: "Caldos",
    tagline: "Caldos tradicionais da casa",
    banner: "assets/abre-alas-caldos.png"
  },
  {
    id: "sobremesas",
    name: "Sobremesas",
    tagline: "Sobremesas e pastéis doces",
    banner: "assets/abre-alas-sobremesas.png"
  },
  {
    id: "bebidas",
    name: "Bebidas",
    tagline: "Cervejas, caipirinhas, destilados, doses, sucos e refrigerantes",
    banner: "assets/abre-alas-bebidas.png"
  }
];

export const PRODUCTS = [
  // ==========================================
  // 01 — LANCHES (Páginas 7 e 8)
  // ==========================================
  // Tradicional (Pág 7)
  {
    id: "lanche-hamburguer",
    categoryId: "lanches",
    subCategory: "Tradicional",
    name: "Hambúrguer",
    description: "Pão com Gergelim, Bife de Hambúrguer, Milho, Salada e Batata Palha",
    price: 13.00,
    allowBurgerAddons: true
  },
  {
    id: "lanche-hamb-ovo",
    categoryId: "lanches",
    subCategory: "Tradicional",
    name: "Hambúrguer com Ovo",
    description: "Pão com Gergelim, Bife de Hambúrguer, Ovo, Milho, Salada e Batata Palha",
    price: 16.00,
    allowBurgerAddons: true
  },
  {
    id: "lanche-hamb-bacon",
    categoryId: "lanches",
    subCategory: "Tradicional",
    name: "Hambúrguer com Bacon",
    description: "Pão com Gergelim, Bife de Hambúrguer, Bacon, Milho, Salada e Batata Palha",
    price: 18.00,
    allowBurgerAddons: true
  },
  {
    id: "lanche-x-burguer",
    categoryId: "lanches",
    subCategory: "Tradicional",
    name: "X-Burguer",
    description: "Pão com Gergelim, Bife de Hambúrguer, Muçarela, Presunto, Milho, Salada e Batata Palha",
    price: 17.00,
    allowBurgerAddons: true
  },
  {
    id: "lanche-x-bacon",
    categoryId: "lanches",
    subCategory: "Tradicional",
    name: "X-Bacon",
    description: "Pão com Gergelim, Bife de Hambúrguer, Bacon, Presunto, Muçarela, Milho, Salada e Batata Palha",
    price: 22.00,
    allowBurgerAddons: true
  },
  {
    id: "lanche-x-egg",
    categoryId: "lanches",
    subCategory: "Tradicional",
    name: "X-Egg",
    description: "Pão com Gergelim, Bife de Hambúrguer, Ovo, Presunto, Muçarela, Milho, Salada e Batata Palha",
    price: 20.00,
    allowBurgerAddons: true
  },
  {
    id: "lanche-x-tudo",
    categoryId: "lanches",
    subCategory: "Tradicional",
    name: "X-Tudo",
    description: "Pão com Gergelim, Bife de Hambúrguer, Ovo, Bacon, Milho, Presunto, Muçarela, Salada e Batata Palha",
    price: 25.00,
    allowBurgerAddons: true
  },
  {
    id: "lanche-x-tudo-duplo",
    categoryId: "lanches",
    subCategory: "Tradicional",
    name: "X-Tudo Duplo",
    description: "Pão com Gergelim, 2 Bifes de Hambúrguer, Presunto Duplo, Muçarela Dupla, Bacon em Dobro, 2 Ovos, Milho, Salada e Batata Palha",
    price: 37.00,
    allowBurgerAddons: true
  },
  {
    id: "lanche-x-lazao",
    categoryId: "lanches",
    subCategory: "Tradicional",
    name: "X-Lazão",
    description: "Pão com Gergelim, 2 Bifes de Hambúrguer, Presunto Duplo, Muçarela Dupla, Bacon em Dobro, 2 Ovos, Filé de Frango, Milho, Salada e Batata Palha",
    price: 40.00,
    highlight: true,
    allowBurgerAddons: true
  },
  // Calabresa (Pág 7)
  {
    id: "lanche-x-calabresa",
    categoryId: "lanches",
    subCategory: "Calabresa",
    name: "X-Calabresa",
    description: "Pão com Gergelim, Bife de Hambúrguer, Calabresa, Presunto, Muçarela, Milho, Salada e Batata Palha",
    price: 22.00,
    allowBurgerAddons: true
  },
  {
    id: "lanche-x-calabresa-egg",
    categoryId: "lanches",
    subCategory: "Calabresa",
    name: "X-Calabresa Egg",
    description: "Pão com Gergelim, Bife de Hambúrguer, Calabresa, Ovo, Presunto, Muçarela, Milho, Salada e Batata Palha",
    price: 24.00,
    allowBurgerAddons: true
  },
  {
    id: "lanche-x-calabresa-bacon",
    categoryId: "lanches",
    subCategory: "Calabresa",
    name: "X-Calabresa Bacon",
    description: "Pão com Gergelim, Bife de Hambúrguer, Calabresa, Presunto, Muçarela, Bacon, Milho, Salada e Batata Palha",
    price: 26.00,
    allowBurgerAddons: true
  },
  {
    id: "lanche-x-calabresa-tudo",
    categoryId: "lanches",
    subCategory: "Calabresa",
    name: "X-Calabresa Tudo",
    description: "Pão com Gergelim, Bife de Hambúrguer, Calabresa, Bacon, Presunto, Muçarela, Ovo, Milho, Salada e Batata Palha",
    price: 28.00,
    allowBurgerAddons: true
  },
  // Picanha (Pág 8)
  {
    id: "lanche-x-picanha",
    categoryId: "lanches",
    subCategory: "Picanha",
    name: "X-Picanha",
    description: "Pão com Gergelim, Hambúrguer de Picanha, Presunto, Muçarela, Milho, Salada e Batata Palha",
    price: 24.00,
    allowBurgerAddons: true
  },
  {
    id: "lanche-x-picanha-egg",
    categoryId: "lanches",
    subCategory: "Picanha",
    name: "X-Picanha Egg",
    description: "Pão com Gergelim, Hambúrguer de Picanha, Ovo, Presunto, Muçarela, Milho, Salada e Batata Palha",
    price: 26.00,
    allowBurgerAddons: true
  },
  {
    id: "lanche-x-picanha-bacon",
    categoryId: "lanches",
    subCategory: "Picanha",
    name: "X-Picanha Bacon",
    description: "Pão com Gergelim, Hambúrguer de Picanha, Bacon, Presunto, Muçarela, Milho, Salada e Batata Palha",
    price: 28.00,
    allowBurgerAddons: true
  },
  {
    id: "lanche-x-picanha-tudo",
    categoryId: "lanches",
    subCategory: "Picanha",
    name: "X-Picanha Tudo",
    description: "Pão com Gergelim, Hambúrguer de Picanha, Bacon, Ovo, Presunto, Muçarela, Milho, Salada e Batata Palha",
    price: 30.00,
    allowBurgerAddons: true
  },
  // Artesanal (Pág 8)
  {
    id: "lanche-artesanal-simples",
    categoryId: "lanches",
    subCategory: "Artesanal",
    name: "Hambúrguer Artesanal",
    description: "Pão com Gergelim, Bife de Hambúrguer 120g, Milho, Salada e Batata Palha",
    price: 18.00,
    allowBurgerAddons: true
  },
  {
    id: "lanche-x-burguer-artesanal",
    categoryId: "lanches",
    subCategory: "Artesanal",
    name: "X-Burguer Artesanal",
    description: "Pão com Gergelim, Bife de Hambúrguer 120g, Presunto, Muçarela, Milho, Salada e Batata Palha",
    price: 22.00,
    allowBurgerAddons: true
  },
  {
    id: "lanche-x-egg-artesanal",
    categoryId: "lanches",
    subCategory: "Artesanal",
    name: "X-Egg Artesanal",
    description: "Pão com Gergelim, Bife de Hambúrguer 120g, Presunto, Muçarela, Ovo, Milho, Salada e Batata Palha",
    price: 24.00,
    allowBurgerAddons: true
  },
  {
    id: "lanche-x-bacon-artesanal",
    categoryId: "lanches",
    subCategory: "Artesanal",
    name: "X-Bacon Artesanal",
    description: "Pão com Gergelim, Bife de Hambúrguer 120g, Bacon, Muçarela, Presunto, Milho, Salada e Batata Palha",
    price: 25.00,
    allowBurgerAddons: true
  },
  {
    id: "lanche-x-tudo-artesanal",
    categoryId: "lanches",
    subCategory: "Artesanal",
    name: "X-Tudo Artesanal",
    description: "Pão com Gergelim, Hambúrguer de 120g, Bacon, Ovo, Presunto, Muçarela, Milho, Salada e Batata Palha",
    price: 29.00,
    allowBurgerAddons: true
  },
  {
    id: "lanche-super-cheddar",
    categoryId: "lanches",
    subCategory: "Artesanal",
    name: "Super Cheddar",
    description: "Pão com Gergelim, Bife Artesanal 120g, Bacon e Cheddar",
    price: 25.00,
    allowBurgerAddons: true
  },
  {
    id: "lanche-super-cheddar-duplo",
    categoryId: "lanches",
    subCategory: "Artesanal",
    name: "Super Cheddar Duplo",
    description: "Pão com Gergelim, 2 Bifes Artesanais 120g, Bacon em Dobro e Cheddar em Dobro",
    price: 35.00,
    allowBurgerAddons: true
  },
  // Especiais (Pág 8)
  {
    id: "lanche-bh-no-prato",
    categoryId: "lanches",
    subCategory: "Especiais no Prato",
    name: "BH no Prato",
    description: "Pão com Gergelim, Bife de Hambúrguer 150g, Ovo, Muçarela, Presunto, Milho, Salada e Batata Frita",
    price: 30.00,
    allowBurgerAddons: true
  },
  {
    id: "lanche-rj-no-prato",
    categoryId: "lanches",
    subCategory: "Especiais no Prato",
    name: "RJ no Prato",
    description: "Pão com Gergelim, Bife de Hambúrguer 150g, Bacon, Muçarela, Presunto, Milho, Salada e Batata Frita",
    price: 34.00,
    allowBurgerAddons: true
  },
  {
    id: "lanche-sp-no-prato",
    categoryId: "lanches",
    subCategory: "Especiais no Prato",
    name: "SP no Prato",
    description: "Pão com Gergelim, Bife de Hambúrguer 150g, Ovo, Bacon, Muçarela, Presunto, Milho, Salada e Batata Frita",
    price: 38.00,
    allowBurgerAddons: true
  },
  // Frango (Pág 8)
  {
    id: "lanche-x-frango-egg",
    categoryId: "lanches",
    subCategory: "Frango",
    name: "X-Frango Egg",
    description: "Pão com Gergelim, Filé de Frango, Ovo, Presunto, Muçarela, Milho, Salada e Batata Palha",
    price: 24.00,
    allowBurgerAddons: true
  },
  {
    id: "lanche-x-frango-bacon",
    categoryId: "lanches",
    subCategory: "Frango",
    name: "X-Frango Bacon",
    description: "Pão com Gergelim, Filé de Frango, Bacon, Presunto, Muçarela, Milho, Salada e Batata Palha",
    price: 26.00,
    allowBurgerAddons: true
  },
  {
    id: "lanche-x-frango-tudo",
    categoryId: "lanches",
    subCategory: "Frango",
    name: "X-Frango Tudo",
    description: "Pão com Gergelim, Filé de Frango, Ovo, Presunto, Muçarela, Bacon, Milho, Salada e Batata Palha",
    price: 29.00,
    allowBurgerAddons: true
  },

  // ==========================================
  // 02 — JANTINHAS (Página 4)
  // Comprovado na Página 4 do Cardápio Super Lazin 01.pdf
  // ==========================================
  {
    id: "jantinha-completa",
    categoryId: "jantinhas",
    name: "Jantinha",
    description: "Acompanha: arroz, feijão, salada | farofa ou vinagrete | batata ou mandioca.",
    basePrice: 22.00,
    isJantinhaBuilder: true
  },
  {
    id: "jantinha-arroz-2p",
    categoryId: "jantinhas",
    name: "Arroz | Para 2 Pessoas",
    description: "Porção à la carte do cardápio",
    price: 10.00
  },
  {
    id: "jantinha-feijao-2p",
    categoryId: "jantinhas",
    name: "Feijão | Para 2 Pessoas",
    description: "Porção à la carte do cardápio",
    price: 10.00
  },
  {
    id: "jantinha-farofa-2p",
    categoryId: "jantinhas",
    name: "Farofa | Para 2 Pessoas",
    description: "Porção à la carte do cardápio",
    price: 10.00
  },

  // ==========================================
  // 03 — PIZZAS (Páginas 9, 10 e 11)
  // ==========================================
  // Clássicas (Pág 9)
  {
    id: "pizza-alho",
    categoryId: "pizzas",
    subCategory: "Clássicas",
    name: "1) Alho",
    description: "Molho de Tomate, Muçarela e Alho",
    prices: { broto: 24.00, media: 35.00, familia: 43.00, mega: 54.00 }
  },
  {
    id: "pizza-atum",
    categoryId: "pizzas",
    subCategory: "Clássicas",
    name: "2) Atum",
    description: "Molho de Tomate, Muçarela, Atum e Cebola",
    prices: { broto: 34.00, media: 52.00, familia: 65.00, mega: 75.00 }
  },
  {
    id: "pizza-bacon",
    categoryId: "pizzas",
    subCategory: "Clássicas",
    name: "3) Bacon",
    description: "Molho de Tomate, Muçarela e Bacon",
    prices: { broto: 30.00, media: 42.00, familia: 55.00, mega: 65.00 }
  },
  {
    id: "pizza-calabresa",
    categoryId: "pizzas",
    subCategory: "Clássicas",
    name: "4) Calabresa",
    description: "Molho de Tomate, Muçarela, Calabresa e Cebola",
    prices: { broto: 33.00, media: 48.00, familia: 59.00, mega: 70.00 }
  },
  {
    id: "pizza-frango-catupiry",
    categoryId: "pizzas",
    subCategory: "Clássicas",
    name: "5) Frango Catupiry",
    description: "Molho de Tomate, Frango Desfiado, Catupiry e Muçarela",
    prices: { broto: 36.00, media: 56.00, familia: 68.00, mega: 78.00 }
  },
  {
    id: "pizza-frango-cheddar",
    categoryId: "pizzas",
    subCategory: "Clássicas",
    name: "6) Frango Cheddar",
    description: "Molho de Tomate, Frango Desfiado, Cheddar e Muçarela",
    prices: { broto: 36.00, media: 56.00, familia: 68.00, mega: 78.00 }
  },
  {
    id: "pizza-lombo-canadense",
    categoryId: "pizzas",
    subCategory: "Clássicas",
    name: "7) Lombo Canadense",
    description: "Molho de Tomate, Muçarela, Lombo Canadense e Catupiry",
    prices: { broto: 32.00, media: 48.00, familia: 59.00, mega: 71.00 }
  },
  {
    id: "pizza-marguerita",
    categoryId: "pizzas",
    subCategory: "Clássicas",
    name: "8) Marguerita",
    description: "Molho de Tomate, Muçarela, Manjericão e Tomate",
    prices: { broto: 28.00, media: 37.00, familia: 46.00, mega: 61.00 }
  },
  {
    id: "pizza-mista",
    categoryId: "pizzas",
    subCategory: "Clássicas",
    name: "9) Mista",
    description: "Molho de Tomate, Presunto, Muçarela, Tomate e Cebola",
    prices: { broto: 29.00, media: 39.00, familia: 49.00, mega: 60.00 }
  },
  {
    id: "pizza-palmito",
    categoryId: "pizzas",
    subCategory: "Clássicas",
    name: "10) Palmito",
    description: "Molho de Tomate, Muçarela, Palmito e Azeitonas Pretas",
    prices: { broto: 30.00, media: 41.00, familia: 62.00, mega: 72.00 }
  },
  {
    id: "pizza-portuguesa",
    categoryId: "pizzas",
    subCategory: "Clássicas",
    name: "11) Portuguesa",
    description: "Molho de Tomate, Muçarela, Presunto, Calabresa, Tomate, Ovo, Pimentão, Cebola e Azeitonas",
    prices: { broto: 32.00, media: 49.00, familia: 64.00, mega: 72.00 }
  },
  {
    id: "pizza-mucarela",
    categoryId: "pizzas",
    subCategory: "Clássicas",
    name: "12) Muçarela",
    description: "Molho de Tomate, Muçarela, Tomate",
    prices: { broto: 25.00, media: 35.00, familia: 45.00, mega: 56.00 }
  },
  {
    id: "pizza-calabresa-catupiry",
    categoryId: "pizzas",
    subCategory: "Clássicas",
    name: "13) Calabresa com Catupiry",
    description: "Molho de Tomate, Muçarela, Calabresa, Catupiry e Cebola",
    prices: { broto: 36.00, media: 56.00, familia: 68.00, mega: 77.00 }
  },
  // Calzone (Pág 9)
  {
    id: "calzone-especial",
    categoryId: "pizzas",
    subCategory: "Calzone",
    name: "Calzone",
    description: "Sabores: Frango, Calabresa, Fit, Mercador, Nutella e Banana",
    price: 35.00,
    isCalzone: true,
    flavors: ["Frango", "Calabresa", "Fit", "Mercador", "Nutella", "Banana"]
  },
  // Especiais (Pág 10)
  {
    id: "pizza-moda-cheff",
    categoryId: "pizzas",
    subCategory: "Especiais",
    name: "14) A Moda do Cheff",
    description: "Molho de Tomate, Muçarela, Calabresa, Bacon, Cebola e Alho Frito",
    prices: { broto: 37.00, media: 50.00, familia: 62.00, mega: 75.00 }
  },
  {
    id: "pizza-moda-pizzaiolo",
    categoryId: "pizzas",
    subCategory: "Especiais",
    name: "15) A Moda do Pizzaiolo",
    description: "Molho de Tomate, Muçarela, Calabresa, Champignon, Palmito, Catupiry e Manjericão",
    prices: { broto: 35.00, media: 57.00, familia: 69.00, mega: 79.00 }
  },
  {
    id: "pizza-bacon-champignon",
    categoryId: "pizzas",
    subCategory: "Especiais",
    name: "16) Bacon Champignon",
    description: "Molho de Tomate, Muçarela, Bacon e Champignon",
    prices: { broto: 32.00, media: 44.00, familia: 61.00, mega: 71.00 }
  },
  {
    id: "pizza-carioca",
    categoryId: "pizzas",
    subCategory: "Especiais",
    name: "17) Carioca",
    description: "Molho de Tomate, Frango Desfiado, Bacon, Tomate, Ovo, Cheddar e Muçarela",
    prices: { broto: 38.00, media: 59.00, familia: 71.00, mega: 81.00 }
  },
  {
    id: "pizza-quatro-queijos",
    categoryId: "pizzas",
    subCategory: "Especiais",
    name: "18) Quatro Queijos",
    description: "Molho de Tomate, Muçarela, Parmesão, Provolone e Catupiry",
    prices: { broto: 36.00, media: 55.00, familia: 67.00, mega: 80.00 }
  },
  {
    id: "pizza-cinco-queijos",
    categoryId: "pizzas",
    subCategory: "Especiais",
    name: "19) Cinco Queijos",
    description: "Molho de Tomate, Muçarela, Parmesão, Provolone, Catupiry e Cheddar",
    prices: { broto: 37.00, media: 56.00, familia: 70.00, mega: 81.00 }
  },
  {
    id: "pizza-seis-queijos",
    categoryId: "pizzas",
    subCategory: "Especiais",
    name: "20) Seis Queijos",
    description: "Molho de Tomate, Muçarela, Parmesão, Provolone, Catupiry, Cheddar e Gorgonzola",
    prices: { broto: 40.00, media: 60.00, familia: 72.00, mega: 84.00 }
  },
  {
    id: "pizza-lombo-bacon",
    categoryId: "pizzas",
    subCategory: "Especiais",
    name: "21) Lombo Bacon",
    description: "Molho de Tomate, Muçarela, Lombo Canadense e Bacon",
    prices: { broto: 32.00, media: 46.00, familia: 58.00, mega: 70.00 }
  },
  {
    id: "pizza-romana",
    categoryId: "pizzas",
    subCategory: "Especiais",
    name: "22) Romana",
    description: "Molho de Tomate, Frango Desfiado, Palmito, Milho Verde e Catupiry",
    prices: { broto: 38.00, media: 59.00, familia: 70.00, mega: 81.00 }
  },
  {
    id: "pizza-peperoni",
    categoryId: "pizzas",
    subCategory: "Especiais",
    name: "23) Peperoni",
    description: "Molho de Tomate, Muçarela, Pepperoni e Azeitona",
    prices: { broto: 35.00, media: 48.00, familia: 65.00, mega: 77.00 }
  },
  {
    id: "pizza-provolombo",
    categoryId: "pizzas",
    subCategory: "Especiais",
    name: "24) Provolombo",
    description: "Molho de Tomate, Muçarela, Lombo Canadense e Provolone",
    prices: { broto: 35.00, media: 51.00, familia: 66.00, mega: 77.00 }
  },
  {
    id: "pizza-frango-bacon",
    categoryId: "pizzas",
    subCategory: "Especiais",
    name: "25) Frango Bacon",
    description: "Molho de Tomate, Frango Desfiado, Bacon e Muçarela",
    prices: { broto: 35.00, media: 54.00, familia: 67.00, mega: 78.00 }
  },
  {
    id: "pizza-presunto-especial",
    categoryId: "pizzas",
    subCategory: "Especiais",
    name: "26) Presunto Especial",
    description: "Molho de Tomate, Presunto enrolado com Catupiry e Muçarela",
    prices: { broto: 33.00, media: 46.00, familia: 58.00, mega: 70.00 }
  },
  {
    id: "pizza-camponesa",
    categoryId: "pizzas",
    subCategory: "Especiais",
    name: "27) Camponesa",
    description: "Molho de Tomate, Muçarela, Champignon, Palmito, Parmesão e Catupiry",
    prices: { broto: 36.00, media: 50.00, familia: 61.00, mega: 71.00 }
  },
  // Premium (Pág 10 e 11)
  {
    id: "pizza-carbonara",
    categoryId: "pizzas",
    subCategory: "Premium",
    name: "28) Carbonara",
    description: "Molho de Tomate, Muçarela, Bacon, Ovo, Catupiry e Alho",
    prices: { broto: 35.00, media: 55.00, familia: 67.00, mega: 80.00 }
  },
  {
    id: "pizza-catuperu",
    categoryId: "pizzas",
    subCategory: "Premium",
    name: "29) Catuperu",
    description: "Molho de Tomate, Muçarela, Peito de Peru e Catupiry",
    prices: { broto: 36.00, media: 50.00, familia: 66.00, mega: 79.00 }
  },
  {
    id: "pizza-extravaganza",
    categoryId: "pizzas",
    subCategory: "Premium",
    name: "30) Extravaganza",
    description: "Molho de Tomate, Muçarela, Salaminho, Pepperoni, Calabresa, Catupiry e Manjericão",
    prices: { broto: 37.00, media: 56.00, familia: 69.00, mega: 80.00 }
  },
  {
    id: "pizza-file-do-lazin",
    categoryId: "pizzas",
    subCategory: "Premium",
    name: "31) Filé do Lazin",
    description: "Molho de Tomate, Muçarela, Tomate, Cebola, Catupiry e Filé Bovino",
    prices: { broto: 40.00, media: 60.00, familia: 71.00, mega: 82.00 }
  },
  {
    id: "pizza-mercador",
    categoryId: "pizzas",
    subCategory: "Premium",
    name: "32) Mercador",
    description: "Molho de Tomate, Muçarela, Bacon, Champignon, Cebola e Catupiry",
    prices: { broto: 36.00, media: 57.00, familia: 69.00, mega: 79.00 }
  },
  {
    id: "pizza-peppercheese",
    categoryId: "pizzas",
    subCategory: "Premium",
    name: "33) Peppercheese",
    description: "Molho de Tomate, Muçarela, Pepperoni, Cream cheese, Manjericão e Azeitona",
    prices: { broto: 40.00, media: 59.00, familia: 71.00, mega: 81.00 }
  },
  {
    id: "pizza-praiana",
    categoryId: "pizzas",
    subCategory: "Premium",
    name: "34) Praiana",
    description: "Molho de Tomate, Muçarela, Alho-poró, Catupiry e Camarão",
    prices: { broto: 40.00, media: 60.00, familia: 71.00, mega: 82.00 }
  },
  {
    id: "pizza-salmao",
    categoryId: "pizzas",
    subCategory: "Premium",
    name: "35) Salmão",
    description: "Molho de Tomate, Muçarela, Salmão, Cream cheese e Alho-poró",
    prices: { broto: 41.00, media: 61.00, familia: 72.00, mega: 83.00 }
  },
  {
    id: "pizza-toscana",
    categoryId: "pizzas",
    subCategory: "Premium",
    name: "36) Toscana",
    description: "Molho de Tomate, Frango Desfiado, Bacon, Catupiry, Parmesão e Muçarela",
    prices: { broto: 38.00, media: 60.00, familia: 70.00, mega: 80.00 }
  },
  {
    id: "pizza-peruana",
    categoryId: "pizzas",
    subCategory: "Premium",
    name: "37) Peruana",
    description: "Molho de Tomate, Muçarela, Alho-poró, Tomate Cereja e Canudos de Peito de Peru enrolados com Catupiry",
    prices: { broto: 40.00, media: 60.00, familia: 70.00, mega: 80.00 }
  },
  // Doces (Pág 11)
  {
    id: "pizza-banana",
    categoryId: "pizzas",
    subCategory: "Doces",
    name: "38) Banana",
    description: "Muçarela, Banana, Leite Condensado e Canela",
    prices: { broto: 27.00, media: 39.00, familia: 48.00, mega: 59.00 }
  },
  {
    id: "pizza-brigadeiro",
    categoryId: "pizzas",
    subCategory: "Doces",
    name: "39) Brigadeiro",
    description: "Muçarela, Chocolate e Chocolate Granulado",
    prices: { broto: 30.00, media: 40.00, familia: 50.00, mega: 60.00 }
  },
  {
    id: "pizza-confete",
    categoryId: "pizzas",
    subCategory: "Doces",
    name: "40) Confete",
    description: "Muçarela, Chocolate e Confete",
    prices: { broto: 30.00, media: 41.00, familia: 53.00, mega: 63.00 }
  },
  {
    id: "pizza-kit-kat",
    categoryId: "pizzas",
    subCategory: "Doces",
    name: "41) Kit Kat",
    description: "Muçarela, Chocolate, Kit Kat e Castanha",
    prices: { broto: 33.00, media: 46.00, familia: 61.00, mega: 72.00 }
  },
  {
    id: "pizza-nutella-ninho",
    categoryId: "pizzas",
    subCategory: "Doces",
    name: "42) Nutella Ninho",
    description: "Molho de Tomate, Muçarela, Bacon, Champignon, Cebola e Catupiry (PENDÊNCIA HOMOLOGADA: descrição impressa no PDF original é inconsistente com o sabor)",
    prices: { broto: 34.00, media: 53.00, familia: 66.00, mega: 78.00 },
    hasPendingNote: true
  },
  {
    id: "pizza-nutella-sorvete",
    categoryId: "pizzas",
    subCategory: "Doces",
    name: "43) Nutella Sorvete",
    description: "Muçarela, Nutella, Sorvete de Creme e Cobertura de Chocolate",
    prices: { broto: 36.00, media: 56.00, familia: 69.00, mega: 81.00 }
  },
  {
    id: "pizza-nutella-morango",
    categoryId: "pizzas",
    subCategory: "Doces",
    name: "44) Nutella Morango",
    description: "Muçarela, Nutella e Morango",
    prices: { broto: 36.00, media: 56.00, familia: 69.00, mega: 81.00 }
  },
  {
    id: "pizza-prestigio",
    categoryId: "pizzas",
    subCategory: "Doces",
    name: "45) Prestígio",
    description: "Muçarela, Chocolate, Coco e Leite Condensado",
    prices: { broto: 30.00, media: 41.00, familia: 51.00, mega: 62.00 }
  },
  {
    id: "pizza-churros",
    categoryId: "pizzas",
    subCategory: "Doces",
    name: "46) Churros",
    description: "Muçarela, Doce de Leite, Canela e Açúcar",
    prices: { broto: 36.00, media: 56.00, familia: 69.00, mega: 81.00 }
  },

  // ==========================================
  // 04 — DI BUTECO (Página 6)
  // ==========================================
  {
    id: "di-buteco-porquinho-rabico",
    categoryId: "di-buteco",
    name: "Porquinho Rabicó",
    description: "Iscas de lombo temperado ao vinho com alecrim farofa de bacon com ervas e geleia de caipirinha",
    price: 40.00,
    image: "assets/foto-porquinho-rabico.png",
    diButecoOfficial: true,
    highlight: true
  },
  {
    id: "di-buteco-surfista-prateado",
    categoryId: "di-buteco",
    name: "Surfista Prateado",
    description: "Costelinha suína empanada na farinha Panko acompanhada de geleia de vinho",
    price: null, // PENDÊNCIA HOMOLOGADA: Preço pendente de confirmação com Lazinho
    pricePending: true,
    priceLabel: "Preço sob confirmação",
    image: "assets/foto-surfista-prateado.png",
    diButecoOfficial: true,
    highlight: true
  },
  {
    id: "di-buteco-boi-supremo",
    categoryId: "di-buteco",
    name: "Boi Supremo",
    description: "Isca de miolo da alcatra com catupiry, alho-poró flambado com muçarela.",
    price: null, // PENDÊNCIA HOMOLOGADA: Preço pendente de confirmação com Lazinho
    pricePending: true,
    priceLabel: "Preço sob confirmação",
    image: "assets/foto-boi-supremo.png",
    diButecoOfficial: true,
    highlight: true
  },

  // ==========================================
  // 05 — PORÇÕES (Página 5)
  // Regra canônica: "Meia Porção será cobrada por 60% do valor da porção inteira."
  // ==========================================
  {
    id: "porcao-trio-mineiro",
    categoryId: "porcoes",
    name: "Trio Mineiro | Mandioca, linguiça e torresmo",
    description: "Mandioca, linguiça e torresmo",
    price: 59.00,
    supportsHalf: true
  },
  {
    id: "porcao-contra-file-fritas",
    categoryId: "porcoes",
    name: "Contra Filé com Fritas",
    description: "Porção de contra filé com fritas",
    price: 68.00,
    supportsHalf: true
  },
  {
    id: "porcao-lombo-fritas",
    categoryId: "porcoes",
    name: "Lombo com Fritas",
    description: "Porção de lombo com fritas",
    price: 53.00,
    supportsHalf: true
  },
  {
    id: "porcao-linguica-fritas",
    categoryId: "porcoes",
    name: "Linguiça com Fritas",
    description: "Porção de linguiça com fritas",
    price: 50.00,
    supportsHalf: true
  },
  {
    id: "porcao-boi-magia",
    categoryId: "porcoes",
    name: "Boi Magia",
    description: "Porção Boi Magia",
    price: 80.00,
    supportsHalf: true
  },
  {
    id: "porcao-boi-fritas",
    categoryId: "porcoes",
    name: "Boi com Fritas",
    description: "Porção de carne de boi com fritas",
    price: 70.00,
    supportsHalf: true
  },
  {
    id: "porcao-file-tilapia",
    categoryId: "porcoes",
    name: "Filé de Tilápia",
    description: "Porção de filé de tilápia",
    price: 55.00,
    supportsHalf: true
  },
  {
    id: "porcao-torresmo",
    categoryId: "porcoes",
    name: "Torresmo",
    description: "Porção de torresmo crocante",
    price: 45.00,
    supportsHalf: true
  },
  {
    id: "porcao-trio-do-lazin",
    categoryId: "porcoes",
    name: "Trio do Lazin | Contra filé, lombo e linguiça",
    description: "Contra filé, lombo e linguiça",
    price: 80.00,
    highlight: true,
    supportsHalf: true
  },
  {
    id: "porcao-frango-passarinho",
    categoryId: "porcoes",
    name: "Frango a Passarinho",
    description: "Porção de frango a passarinho",
    price: 48.00,
    supportsHalf: true
  },

  // ==========================================
  // 06 — PARA COMPARTILHAR (Página 5)
  // ==========================================
  {
    id: "compartilhar-pastel-frango-catupiry",
    categoryId: "para-compartilhar",
    name: "Pastel de Frango com Catupiry e Alho-Poró | 10 unid.",
    description: "10 unidades",
    price: 30.00
  },
  {
    id: "compartilhar-pastel-camarao",
    categoryId: "para-compartilhar",
    name: "Pastel de Camarão | 10 unid.",
    description: "10 unidades",
    price: 33.00
  },
  {
    id: "compartilhar-pastel-pizza-queijo",
    categoryId: "para-compartilhar",
    name: "Pastel Pizza ou Queijo | 10 unid.",
    description: "10 unidades",
    price: 30.00
  },
  {
    id: "compartilhar-bolinha-queijo",
    categoryId: "para-compartilhar",
    name: "Bolinha de Queijo | 20 unid.",
    description: "20 unidades",
    price: 32.00
  },
  {
    id: "compartilhar-bolinho-bacalhau",
    categoryId: "para-compartilhar",
    name: "Bolinho de Bacalhau | 10 unid.",
    description: "10 unidades",
    price: 40.00
  },
  {
    id: "compartilhar-camafeu-camarao",
    categoryId: "para-compartilhar",
    name: "Camafeu de Camarão | 10 unid.",
    description: "10 unidades",
    price: 42.00
  },

  // ==========================================
  // 07 — FRITAS (Página 4)
  // Literalmente conforme Página 4 do Cardápio Super Lazin 01.pdf
  // ==========================================
  {
    id: "fritas-pequena",
    categoryId: "fritas",
    name: "Fritas Pequena",
    description: "Porção de fritas pequena",
    price: 10.00
  },
  {
    id: "fritas-grandes",
    categoryId: "fritas",
    name: "Fritas Grandes",
    description: "Porção de fritas grandes",
    price: 32.00
  },
  {
    id: "fritas-queijo",
    categoryId: "fritas",
    name: "Fritas com Queijo",
    description: "Batatas fritas com cobertura de queijo",
    price: 36.00
  },
  {
    id: "fritas-bacon",
    categoryId: "fritas",
    name: "Fritas com Bacon",
    description: "Batatas fritas com bacon",
    price: 40.00
  },
  {
    id: "fritas-bacon-catupiry-cheddar",
    categoryId: "fritas",
    name: "Fritas com Bacon Catupiry ou Cheddar",
    description: "Batatas fritas com bacon, catupiry ou cheddar",
    price: 48.00
  },

  // ==========================================
  // 08 — CALDOS (Página 4)
  // Preços finais atualizados conforme renderização da Página 4 do Cardápio Super Lazin 01.pdf
  // ==========================================
  {
    id: "caldo-canjiquinha",
    categoryId: "caldos",
    name: "Canjiquinha",
    description: "Caldo de canjiquinha tradicional",
    price: 19.00
  },
  {
    id: "caldo-angu-file-requeijao",
    categoryId: "caldos",
    name: "Angu com Filé e Requeijão",
    description: "Angu com filé e requeijão",
    price: 20.00
  },
  {
    id: "caldo-feijao-amigo",
    categoryId: "caldos",
    name: "Feijão Amigo",
    description: "Caldo de feijão amigo",
    price: 19.00
  },
  {
    id: "caldo-vaca-atolada",
    categoryId: "caldos",
    name: "Vaca Atolada",
    description: "Caldo de vaca atolada",
    price: 19.00
  },

  // ==========================================
  // 09 — SOBREMESAS (Página 6)
  // ==========================================
  {
    id: "sobremesa-petit-gateau",
    categoryId: "sobremesas",
    name: "Petit Gateau com Sorvete",
    description: "Bolo petit gateau com sorvete",
    price: 18.00
  },
  {
    id: "sobremesa-pastel-romeu-julieta",
    categoryId: "sobremesas",
    name: "Pastel Romeu e Julieta | 10 unid.",
    description: "10 unidades",
    price: 31.00
  },
  {
    id: "sobremesa-pastel-churros",
    categoryId: "sobremesas",
    name: "Pastel de Churros | 10 unid.",
    description: "10 unidades",
    price: 31.00
  },

  // ==========================================
  // 10 — BEBIDAS (Páginas 2 e 3)
  // ==========================================
  // Não Alcoólicas (Pág 2)
  {
    id: "bebida-agua-comum",
    categoryId: "bebidas",
    subCategory: "Não Alcoólicas",
    name: "Água Comum",
    description: "Água mineral sem gás",
    price: 3.00
  },
  {
    id: "bebida-agua-gas",
    categoryId: "bebidas",
    subCategory: "Não Alcoólicas",
    name: "Água com Gás",
    description: "Água mineral com gás",
    price: 4.00
  },
  {
    id: "bebida-suco-laranja",
    categoryId: "bebidas",
    subCategory: "Não Alcoólicas",
    name: "Suco de Laranja",
    description: "Suco de laranja natural",
    price: 7.00
  },
  {
    id: "bebida-suco-lata",
    categoryId: "bebidas",
    subCategory: "Não Alcoólicas",
    name: "Suco Lata",
    description: "Suco em lata",
    price: 7.00
  },
  {
    id: "bebida-suco-1l",
    categoryId: "bebidas",
    subCategory: "Não Alcoólicas",
    name: "Suco 1 Litro",
    description: "Jarra de suco 1L",
    price: 11.00
  },
  {
    id: "bebida-limoneto-h2o",
    categoryId: "bebidas",
    subCategory: "Não Alcoólicas",
    name: "Limoneto H2O",
    description: "H2O Limoneto",
    price: 9.00
  },
  {
    id: "bebida-refri-350ml",
    categoryId: "bebidas",
    subCategory: "Não Alcoólicas",
    name: "Refrigerante 350ml",
    description: "Lata 350ml",
    price: 7.00
  },
  {
    id: "bebida-refri-600ml",
    categoryId: "bebidas",
    subCategory: "Não Alcoólicas",
    name: "Refrigerante 600ml",
    description: "Garrafa 600ml",
    price: 9.00
  },
  {
    id: "bebida-refri-1l-coca",
    categoryId: "bebidas",
    subCategory: "Não Alcoólicas",
    name: "Refrigerante 1L | Coca-Cola",
    description: "Garrafa 1L Coca-Cola",
    price: 11.00
  },
  {
    id: "bebida-refri-1l-guarana",
    categoryId: "bebidas",
    subCategory: "Não Alcoólicas",
    name: "Refrigerante 1L | Guaraná",
    description: "Garrafa 1L Guaraná",
    price: 10.00
  },
  {
    id: "bebida-refri-2l-coca",
    categoryId: "bebidas",
    subCategory: "Não Alcoólicas",
    name: "Refrigerante 2L | Coca-Cola",
    description: "Garrafa 2L Coca-Cola",
    price: 16.00
  },
  {
    id: "bebida-refri-2l-guarana",
    categoryId: "bebidas",
    subCategory: "Não Alcoólicas",
    name: "Refrigerante 2L | Guaraná",
    description: "Garrafa 2L Guaraná",
    price: 12.00
  },
  {
    id: "bebida-energetico",
    categoryId: "bebidas",
    subCategory: "Não Alcoólicas",
    name: "Energético",
    description: "Energético lata",
    price: 14.00
  },
  {
    id: "bebida-limonada-suica",
    categoryId: "bebidas",
    subCategory: "Não Alcoólicas",
    name: "Limonada Suíça",
    description: "Limonada suíça",
    price: 7.00
  },
  {
    id: "bebida-limonada-suica-cremosa",
    categoryId: "bebidas",
    subCategory: "Não Alcoólicas",
    name: "Limonada Suíça | Cremosa",
    description: "Limonada suíça cremosa",
    price: 9.00
  },
  // Cervejas (Pág 2)
  {
    id: "bebida-amstel-600ml",
    categoryId: "bebidas",
    subCategory: "Cervejas",
    name: "Amstel | 600ml",
    description: "Garrafa 600ml",
    price: 13.00
  },
  {
    id: "bebida-brahma-skol-600ml",
    categoryId: "bebidas",
    subCategory: "Cervejas",
    name: "Brahma e Skol | 600ml",
    description: "Garrafa 600ml",
    price: 12.00
  },
  {
    id: "bebida-heineken-600ml",
    categoryId: "bebidas",
    subCategory: "Cervejas",
    name: "Heineken | 600ml",
    description: "Garrafa 600ml",
    price: 16.00
  },
  {
    id: "bebida-latao",
    categoryId: "bebidas",
    subCategory: "Cervejas",
    name: "Latão",
    description: "Cerveja latão",
    price: 8.00
  },
  // Caipirinhas (Pág 3)
  {
    id: "drink-caipirinha",
    categoryId: "bebidas",
    subCategory: "Caipirinhas",
    name: "Caipirinha",
    description: "Caipirinha tradicional de cachaça",
    price: 15.00
  },
  {
    id: "drink-caipirissima",
    categoryId: "bebidas",
    subCategory: "Caipirinhas",
    name: "Caipiríssima",
    description: "Caipirinha de vodka",
    price: 17.00
  },
  {
    id: "drink-caipirinha-cremosa",
    categoryId: "bebidas",
    subCategory: "Caipirinhas",
    name: "Caipirinha Cremosa",
    description: "Caipirinha cremosa",
    price: 17.00
  },
  {
    id: "drink-caipirissima-cremosa",
    categoryId: "bebidas",
    subCategory: "Caipirinhas",
    name: "Caipiríssima Cremosa",
    description: "Caipiríssima cremosa",
    price: 19.00
  },
  {
    id: "drink-caipirinha-morango",
    categoryId: "bebidas",
    subCategory: "Caipirinhas",
    name: "Caipirinha de Morango",
    description: "Caipirinha de morango",
    price: 17.00
  },
  {
    id: "drink-caipirissima-morango",
    categoryId: "bebidas",
    subCategory: "Caipirinhas",
    name: "Caipiríssima de Morango",
    description: "Caipiríssima de morango",
    price: 19.00
  },
  {
    id: "drink-caipirinha-cremosa-morango",
    categoryId: "bebidas",
    subCategory: "Caipirinhas",
    name: "Caipirinha Cremosa de Morango",
    description: "Caipirinha cremosa de morango",
    price: 19.00
  },
  {
    id: "drink-caipirissima-cremosa-morango",
    categoryId: "bebidas",
    subCategory: "Caipirinhas",
    name: "Caipiríssima Cremosa de Morango",
    description: "Caipiríssima cremosa de morango",
    price: 21.00
  },
  // Destilados (Pág 3)
  {
    id: "dose-gin-tonica",
    categoryId: "bebidas",
    subCategory: "Destilados",
    name: "Gin Tônica",
    description: "Dose gin com tônica",
    price: 19.00
  },
  {
    id: "dose-campari",
    categoryId: "bebidas",
    subCategory: "Destilados",
    name: "Campari",
    description: "Dose de Campari",
    price: 14.00
  },
  {
    id: "dose-smirnoff",
    categoryId: "bebidas",
    subCategory: "Destilados",
    name: "Smirnoff",
    description: "Dose de vodka Smirnoff",
    price: 12.00
  },
  {
    id: "dose-whisky-red-label",
    categoryId: "bebidas",
    subCategory: "Destilados",
    name: "Whisky Red Label",
    description: "Dose de whisky Red Label",
    price: 19.00
  },
  {
    id: "dose-whisky-white-horse",
    categoryId: "bebidas",
    subCategory: "Destilados",
    name: "Whisky White Horse",
    description: "Dose de whisky White Horse",
    price: 17.00
  },
  {
    id: "dose-reserva-51",
    categoryId: "bebidas",
    subCategory: "Destilados",
    name: "Reserva 51",
    description: "Dose de cachaça Reserva 51",
    price: 15.00
  },
  {
    id: "dose-pinga-mel",
    categoryId: "bebidas",
    subCategory: "Destilados",
    name: "Pinga com Mel",
    description: "Dose de pinga com mel",
    price: 8.00
  },
  {
    id: "dose-cachaca-roca",
    categoryId: "bebidas",
    subCategory: "Destilados",
    name: "Cachaça da Roça",
    description: "Dose de cachaça da roça",
    price: 5.00
  },
  {
    id: "dose-cachaca-coquinho",
    categoryId: "bebidas",
    subCategory: "Destilados",
    name: "Cachaça Coquinho",
    description: "Dose de cachaça coquinho",
    price: 6.00
  },
  // Chopes e Vinhos (Pág 3)
  {
    id: "chopp-caneco",
    categoryId: "bebidas",
    subCategory: "Chopes & Vinhos",
    name: "Chopp Caneco",
    description: "Caneco de chopp",
    price: 8.00
  },
  {
    id: "chope-de-vinho-500ml",
    categoryId: "bebidas",
    subCategory: "Chopes & Vinhos",
    name: "Chope de Vinho | 500ml",
    description: "Copo 500ml",
    price: 16.00
  },
  {
    id: "taca-de-vinho",
    categoryId: "bebidas",
    subCategory: "Chopes & Vinhos",
    name: "Taça de Vinho",
    description: "Taça de vinho",
    price: 8.00
  }
];

// Dados comprovados da Jantinha (Página 4 do Cardápio Super Lazin 01.pdf)
export const JANTINHA_CONFIG = {
  name: "Jantinha",
  description: "Acompanha: arroz, feijão, salada | farofa ou vinagrete | batata ou mandioca",
  meats: [
    { id: "boi", name: "Bife de Boi", price: 26.00 },
    { id: "porco", name: "Bife de Porco", price: 22.00 },
    { id: "frango", name: "Bife de Frango", price: 22.00 }
  ],
  includedSides: ["arroz", "feijão", "salada"],
  choice1: {
    title: "Farofa ou Vinagrete",
    options: ["Farofa", "Vinagrete"]
  },
  choice2: {
    title: "Batata ou Mandioca",
    options: ["Batata", "Mandioca"]
  },
  extras: [
    { id: "extra-ovo", name: "Ovo", price: 2.00 },
    { id: "extra-bife-boi", name: "Bife de Boi", price: 7.00 },
    { id: "extra-bife-frango-porco", name: "Bife de Frango ou Porco", price: 5.00 }
  ]
};
